import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

import { cn } from "@/lib/utils";

/** Head of a subpage: back link to the list, title, one line below. */
export const VoltSubpageHeader = ({
  back,
  title,
  description,
  action,
  className,
}: {
  back: { to: string; label: ReactNode };
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between",
      className,
    )}
  >
    <div className="min-w-0">
      <Link
        to={back.to}
        className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
      >
        <ArrowLeft className="size-4" />
        {back.label}
      </Link>
      <h1 className="mt-1 text-2xl font-bold tracking-tight text-balance">
        {title}
      </h1>
      {description ? (
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      ) : null}
    </div>
    {action ? <div className="shrink-0">{action}</div> : null}
  </div>
);
